
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AuditModel, CategoryModel, PlanItemModel, QuestionGroupModel, ResponseModel } from '@/libs/Api';
import { VDA63, Vda64QuestionValidation } from '@/audit-settings/VDA63';

@Component({})
export default class WorkTaskVda63Summary extends Vue {
    @Prop() audit!: AuditModel;
    @Prop() category!: CategoryModel;
    @Prop() item!: PlanItemModel;
    @Prop() questionGroups!: QuestionGroupModel[];
    @Prop() getResponses!: () => ResponseModel[];

    get processElements(): string[] {
        const processElements = this.questionGroups
            .where((x) => x.processElement != null)
            .groupBy((x) => x.processElement!)
            .select((x) => x.first().processElement!)
            .distinct()
            .toArray();
        return VDA63.ProcessElements.where((x) => processElements.contains(x)).toArray();
    }

    getVdaProcessElementValidation(processElement: string): Vda64QuestionValidation {
        return VDA63.ProcessElementsSteps.first((x) => x.Element == processElement).Validation;
    }

    getVdaProcessElementResponseCount(processElement: string): number {
        return this.getResponses()
            .where(
                (x) =>
                    x.question?.questionGroup?.processElement == processElement &&
                    x.scoreValue != null &&
                    x.scoreValue != -1 &&
                    x.scoreValue != null
            )
            .count();
    }

    getVdaProcessElementHiddenProcessStepResponseCount(processElement: string, stepNumber: string): number {
        return this.getResponses()
            .where(
                (x) =>
                    x.question?.questionGroup?.processElement == processElement &&
                    x.processStep?.isHidden == true &&
                    x.processStep?.stepNumber == stepNumber &&
                    x.scoreValue != null &&
                    x.scoreValue != -1 &&
                    x.scoreValue != null
            )
            .count();
    }

    getVdaProcessElementProcessStepResponseCount(processElement: string): number {
        return this.getResponses()
            .where(
                (x) =>
                    x.question?.questionGroup?.processElement == processElement &&
                    x.scoreValue != null &&
                    x.scoreValue != -1 &&
                    this.item!.planItemProcessSteps!.select((n) => n.processStep!).any(
                        (n) => n.id == x.processStepId && n.isHidden != true
                    )
            )
            .groupBy((x) => x.questionId!)
            .count();
    }
}
